import {
    Box,
    Popover,
    List,
    ListItem,
    ListItemText,
    Divider,
    Typography,
    CircularProgress
} from "@mui/material";

const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};

export default function NotificationPopover({
    id,
    open,
    anchorEl,
    onClose,
    loading,
    notifications,
    onItemClick
}) {
    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{ width: 320, maxHeight: 300 }}
        >
            <Box sx={{ width: 320, display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ p: 2, pb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 800 }}>
                        Follow-up Reminders
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: 'gray', fontWeight: 600 }}>
                        {notifications.length > 0 ? `${notifications.length} New` : ''}
                    </Typography>
                </Box>
                <Divider />

                <List sx={{ p: 0, overflowY: 'auto', flexGrow: 1 }}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                            <CircularProgress size={24} />
                        </Box>
                    ) : notifications.length > 0 ? (
                        notifications.map((notification, index) => (
                            <Box key={notification.id}>
                                <ListItem button onClick={() => onItemClick(notification)}>
                                    <ListItemText
                                        primary={notification.label}
                                        secondary={`Follow up on: ${formatDate(notification.date)}`}
                                        primaryTypographyProps={{ fontSize: 14, fontWeight: 600 }}
                                        secondaryTypographyProps={{ fontSize: 12, color: '#525b75cc' }}
                                    />
                                </ListItem>
                                {index < notifications.length - 1 && <Divider />}
                            </Box>
                        ))
                    ) : (
                        <ListItem>
                            <ListItemText
                                primary="No pending follow-ups."
                                primaryTypographyProps={{ fontSize: 14, textAlign: 'center', color: 'gray' }}
                            />
                        </ListItem>
                    )}
                </List>
            </Box>
        </Popover>
    );
}